import { DeckData, SeatDetail } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import Seat from './seat'

const SeatWrapper = ({
    seatData,
    selectedSeatOptions,
    handleAddSeat,
    handleRemoveSeat,
    formatCurrency,
    t
}: {
    seatData: DeckData
    selectedSeatOptions: Partial<SeatDetail>[]
    handleAddSeat: (seat: SeatDetail) => void
    handleRemoveSeat: (seat: SeatDetail) => void
    formatCurrency: (price: number) => string
    t: TranslationFunction<'itineraryPage.addons'>
}) => {
    return (
        <Seat
            seatData={seatData}
            selectedSeatOptions={selectedSeatOptions}
            handleAddSeat={handleAddSeat}
            handleRemoveSeat={handleRemoveSeat}
            formatCurrency={formatCurrency}
            t={t}
        />
    )
}
export default SeatWrapper
